import { render, staticRenderFns } from "./SegmentedButton.vue?vue&type=template&id=6e53773c&scoped=true&"
import script from "./SegmentedButton.vue?vue&type=script&lang=js&"
export * from "./SegmentedButton.vue?vue&type=script&lang=js&"
import style0 from "./SegmentedButton.vue?vue&type=style&index=0&id=6e53773c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e53773c",
  null
  
)

export default component.exports